import React from 'react';
import { TextField } from '@mui/material';

export default function Input(props) {
    const {
        name,
        label,
        value,
        helperText,
        variant = 'outlined',
        error = false,
        onChange,
        ...other
    } = props;
    return (
        <>
            <TextField
                fullWidth
                variant={variant}
                label={label}
                name={name}
                value={value}
                onChange={onChange}
                helperText={helperText}
                {...(error && { error: true, helperText: error })}
                {...other}
            />
        </>
    );
}
